import { render } from "./systemImport.vue?vue&type=template&id=598e8330&scoped=true"
import script from "./systemImport.vue?vue&type=script&lang=js"
export * from "./systemImport.vue?vue&type=script&lang=js"

import "./systemImport.vue?vue&type=style&index=0&id=598e8330&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598e8330"]])

export default __exports__